<template>
  <FullScreenModal :open="open" @close="closeModal">
    <div>
      <h1 class="flex items-center justify-center text-lg sm:text-2xl text-center font-bold">Ajout de la facture</h1>
      <p class="mt-2 sm:mt-4 text-sm text-gray-600">
        Téléversez la facture finale et détaillez les coûts pour clôturer le sinistre.
      </p>
      <CompensationValueAlert
        v-if="replacementHandlingType && claim.compensationValue"
        :compensation-value="claim.compensationValue"
        class="mt-3"
      />
    </div>
    <FormField
      class="mt-3 sm:mt-5"
      id="file_input"
      v-model="file"
      required
      type="file"
      label="Facture"
      field-class="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-hidden dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
      name="invoice_upload"
    />
    <ExtractionStatus
      :extracting="extracting"
      :extraction-error="extractionError"
      :extraction-success="extractionSuccess"
      @dismiss-success="extractionSuccess = false"
    />
    <div class="border-t border-gray-200 pt-5 sm:pt-7 mt-5 sm:mt-7">
      <CostItems :initial-items="costItems" @updated-items="(items) => (costItems = items)" />
      <PricingDetails :claim="claim" :costItems="costItems" />
      <CostItemsConfirmation
        v-if="costItems && costItems.length > 0"
        :confirmed="itemsConfirmed"
        :total-amount="totalTTC"
        document-type="invoice"
        @confirm="itemsConfirmed = true"
      />
    </div>

    <div v-if="itemsConfirmed" class="border-t border-gray-200 pt-5 sm:pt-7 mt-5 sm:mt-7">
      <Checkbox
        id="certification_checkbox"
        v-model="certificationAccepted"
        name="certification"
        label="Je certifie que le produit réparé ou de remplacement, objet de la facture que je mets ce jour en ligne pour règlement, a bien été remis ou expédié au client. Estaly peut prendre contact avec le client afin de vérifier que son sinistre peut être clôturé et s'assurer de sa satisfaction."
        :required="true"
      />
    </div>

    <div
      v-if="file && costItems && costItems.length > 0 && itemsConfirmed && certificationAccepted"
      class="flex justify-center"
    >
      <GenericButton class="mt-5" @click="send">Envoyer la facture</GenericButton>
    </div>
  </FullScreenModal>
</template>
<script>
import {
  FullScreenModal,
  GenericButton,
  FormField,
  Checkbox,
  CostItems,
  PricingDetails,
  CompensationValueAlert,
  ExtractionStatus,
  CostItemsConfirmation,
  computeTotalTTC,
} from "@estaly/ui";
import { extractCostItemsMixin } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    FormField,
    CostItems,
    PricingDetails,
    GenericButton,
    FullScreenModal,
    Checkbox,
    CompensationValueAlert,
    ExtractionStatus,
    CostItemsConfirmation,
  },
  mixins: [extractCostItemsMixin],
  props: ["claim", "open"],
  data: () => {
    return {
      file: null,
      costItems: null,
      certificationAccepted: false,
      itemsConfirmed: false,
    };
  },

  watch: {
    costItems() {
      this.itemsConfirmed = false;
      this.certificationAccepted = false;
    },
  },

  computed: {
    ...mapGetters("claims", ["replacementHandlingType"]),
    totalTTC() {
      return computeTotalTTC(this.costItems);
    },
  },

  methods: {
    ...mapActions("claims", ["uploadInvoice", "extractCostItems"]),
    ...mapActions("notifications", ["notify"]),

    async send() {
      const response = await this.uploadInvoice({
        costItems: this.costItems,
        file: this.file,
      });
      if (response?.success) this.closeModal();
    },
    closeModal() {
      this.$emit("close");
      this.file = null;
      this.costItems = null;
      this.certificationAccepted = false;
      this.itemsConfirmed = false;
    },
  },
};
</script>
